export default {"src":"/_next/static/media/upload-icon.f794ed78.svg","height":21,"width":21};